{
  "RESET_PASSWORD": {
    "TITLE": "Đặt lại mật khẩu",
    "DESCRIPTION": "Nhập địa chỉ email bạn dùng để đăng nhập trung tâm liên lạc để nhận hướng dẫn đặt lại mật khẩu.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "Thư điện tử",
      "PLACEHOLDER": "Vui lòng nhập email.",
      "ERROR": "Vui lòng nhập email hợp lệ."
    },
    "API": {
      "SUCCESS_MESSAGE": "Liên kết đặt lại mật khẩu đã được gửi đến email của bạn.",
      "ERROR_MESSAGE": "Could not connect to chat server. Please try again."
    },
    "SUBMIT": "Gửi"
  }
}
